// Internal Imports
import { GlobalUtils } from "../../utils";

// Methods Imports
import { getCRMAuthURl } from "./IntegrationsMethods";

// Services Imports
import {
  syncCRMUsers,
  syncCRMAccounts,
  syncCRMOppStages,
  syncCRMOpportunities,
  syncCRMProductFamilies,
  syncCRMProducts,
  fetchCrmDetails,
  // eslint-disable-next-line no-unused-vars
  fetchCrmDetailsByType,
  postCRMCallback,
  postCRMUserCallback,
  postCRMConfigData,
  postCRMUserConfigData,
  syncCRMContacts,
  fetchZapierKey,
  fetchZapierKeyForOrg,
  fetchCrmUserDetails,
  fetchAllCrmUserDetails,
  fetchCrmAllUsers,
} from "./IntegrationsServices";

// Destructuring
const { readDataFromLocalStorage, writeDataToLocalStorage } = GlobalUtils;

// get crm config data
export const getCRMInitData = () => dispatch =>
  new Promise((resolve, reject) => {
    fetchCrmDetails()
      .then(response => {
        dispatch({
          type: "CRM_INIT_DATA",
          payload: response.CRMConfig,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getCrmAllUsers = type => dispatch =>
  new Promise((resolve, reject) => {
    fetchCrmAllUsers(type)
      .then(response => {
        dispatch({
          type: "CRM_ALL_USERS",
          payload: response.OAuthTokens ? response.OAuthTokens : [],
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

// post crm config data & then authenticate crm
export const authenticateCRM = (config, redirectedFromUrl) => () =>
  new Promise((resolve, reject) => {
    postCRMConfigData(config)
      .then(response => {
        if (redirectedFromUrl) {
          writeDataToLocalStorage(
            "revv_boxAuthRedirectedFrom",
            redirectedFromUrl,
          );
        }
        const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
        const orgID = btoa(CURRENT_USER.org_id);
        window.location.href = getCRMAuthURl(response.CRMConfig, orgID);
      })
      .catch(error => {
        reject(error);
      });
  });

export const authenticateCRMUser = config => () =>
  new Promise((resolve, reject) => {
    postCRMUserConfigData(config)
      .then(() => {
        const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
        const orgID = btoa(CURRENT_USER.org_id);
        window.location.href = getCRMAuthURl(config, orgID);
      })
      .catch(error => {
        reject(error);
      });
  });

// get crm config data
export const getCRMUserData = crm => dispatch =>
  new Promise((resolve, reject) => {
    fetchCrmUserDetails(crm)
      .then(response => {
        dispatch({
          type: "CRM_USER_INIT_DATA",
          payload: response.CRMConfig,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAllCRMUserData = () => dispatch =>
  new Promise((resolve, reject) => {
    fetchAllCrmUserDetails()
      .then(response => {
        dispatch({
          type: "CRM_ALL_USER_INIT_DATA",
          payload: response.CRMConfig,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

// crm callback after authentication done
export const CRMCallback = (params, type) => dispatch =>
  new Promise((resolve, reject) => {
    postCRMCallback(params, type)
      .then(response => {
        const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
        const updatedUserObj = { ...CURRENT_USER, crm_configured: true };
        writeDataToLocalStorage("revvsalesUser", updatedUserObj);
        dispatch({
          type: "CRM_AUTH_SUCCESS_SFBOX",
          payload: { response, type },
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const CRMCallbackUser = params => dispatch =>
  new Promise((resolve, reject) => {
    postCRMUserCallback(params)
      .then(response => {
        console.debug(response);
        const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
        const updatedUserObj = { ...CURRENT_USER, crm_configured: true };
        writeDataToLocalStorage("revvsalesUser", updatedUserObj);
        dispatch({
          type: "CRM_AUTH_SUCCESS",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

// sync crm data
export const syncCRM = () => async () => {
  try {
    const users = await syncCRMUsers();
    const accounts = await syncCRMAccounts();
    const contacts = await syncCRMContacts();
    const oppsStages = await syncCRMOppStages();
    const opportunities = await syncCRMOpportunities();
    const productCategories = await syncCRMProductFamilies();
    const products = await syncCRMProducts();

    Promise.all([
      users,
      accounts,
      contacts,
      oppsStages,
      opportunities,
      productCategories,
      products,
    ])
      .then(response => response)
      .catch(error => {
        throw error;
      });

    return null;
  } catch (error) {
    throw error;
  }
};

// get zapier key information
export const getZapierKey = () =>
  new Promise((resolve, reject) => {
    fetchZapierKey()
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getZapierKeyForOrg = () =>
  new Promise((resolve, reject) => {
    fetchZapierKeyForOrg()
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
